'use client';

import { useToast } from '@eliadmin/core/src/components/ui/use-toast';
import { deferOverlayComponent } from './dialog';
import type * as Runtime from './toaster-runtime';

const ToasterRuntime = deferOverlayComponent<typeof Runtime.ToasterRuntime>(
  () => import('./toaster-runtime').then(runtime => runtime.ToasterRuntime),
  'ToasterRuntime',
);

export function Toaster() {
  const { toasts } = useToast();
  if (toasts.length === 0) return null;
  return <ToasterRuntime toasts={toasts} />;
}
